import { defineStore } from 'pinia'

// TODO: this store is not in use
export const useAppStore = defineStore('app', {
  state: () => ({
    HasMultipleWorkspaces: false,
    IsInsideWorkspace: false,
    CanEditCurrentWorkspace: false,
    CurrentWorkspace: {},
    WorkspacesList: []
  }),
  getters: {
    CurrentWorkspaceID: (state) => state.CurrentWorkspace?.id ?? null
  },
  actions: {
    // mutations 
    UpdateIsInsideWorkspace(val) {
      this.IsInsideWorkspace = val
    },
    UpdateHasMultipleWorkspaces(val) {
      this.HasMultipleWorkspaces = val
    },
    UpdateCurrentWorkspace(val) {
      this.CurrentWorkspace = val
    },
    UpdateWorkspacesList(val) {
      this.WorkspacesList = val
    },
    UpdateCanEditCurrentWorkspace(val) {
      this.CanEditCurrentWorkspace = val
    },
  },

})
